import { FileText } from 'lucide-react';
import SummarySkeletonLoader from '@/components/loaders/SummarySkeletonLoader';
import { ProjectSummaryProps } from '@/types';
import TextWithClickableQuotes from '@/utils/TextWithClickableQuotes';
import AnalysisSection from '@/components/analysis/AnalysisSection';
import { formatSummaryForClipboard } from '@/utils/formatForClipboard';

function ProjectSummary({
  id,
  title,
  summary,
  isLoading,
  noSummarydata,
  voiceQuotes,
}: ProjectSummaryProps) {
  const hasSummary = !!summary?.length;

  return (
    <AnalysisSection
      id={id}
      title={title}
      variant="highlight"
      icon={<FileText className="h-5 w-5" />}
      copyText={hasSummary ? formatSummaryForClipboard(summary) : undefined}
      hasData={hasSummary}
      noDataText={noSummarydata}
      isLoading={isLoading}
    >
      {isLoading ? (
        <SummarySkeletonLoader />
      ) : (
        <div className="text-[15px] leading-relaxed text-neutral-700">
          <TextWithClickableQuotes text={summary || ''} voiceQuotes={voiceQuotes} />
        </div>
      )}
    </AnalysisSection>
  );
}

export default ProjectSummary;
